import { LayoutSizeContext } from 'App';
import { ConditionIcons } from 'components';
import moment from 'moment';
import React, { useContext } from 'react';

function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

export default function ClosestCurrentConditions({
  closestLocation,
  compact = false,
  panelWidthHintPx,
}) {
  const layout = useContext(LayoutSizeContext);

  if (!closestLocation) {
    return null;
  }

  const replaceChars = (str, chars1, chars2) => {
    return String(str || '').replace(new RegExp(chars1, 'g'), chars2);
  };

  const widthHint = Number.isFinite(panelWidthHintPx) ? panelWidthHintPx : layout.widgetWidth;
  const cityFontSize = compact ? clamp(widthHint * 0.105, 18, 30) : clamp(widthHint * 0.11, 22, 36);
  const metaFontSize = compact
    ? clamp(widthHint * 0.043, 11, 14)
    : clamp(widthHint * 0.047, 12, 15);
  const summaryFontSize = compact
    ? clamp(widthHint * 0.074, 16, 24)
    : clamp(widthHint * 0.082, 18, 28);
  const detailsFontSize = compact
    ? clamp(widthHint * 0.047, 12, 16)
    : clamp(widthHint * 0.052, 13, 17);
  const iconSize = compact ? clamp(widthHint * 0.17, 34, 52) : clamp(widthHint * 0.2, 44, 72);
  const detailsColumns = widthHint >= 360 ? 2 : 1;

  const details = [
    `Humidity: ${closestLocation.humidity}%`,
    `Visibility: ${closestLocation.visibility} mi`,
    `Feels Like: ${closestLocation.comfort}° F`,
    `Pressure: ${closestLocation.baro_pressure} in`,
    `Dew Point: ${closestLocation.dew_point}° F`,
    `Precipitation: ${closestLocation.precip || 0}%`,
  ];

  return (
    <div className="m-0 d-flex flex-column" style={{ minWidth: 0 }}>
      <div
        className="fw-bold"
        style={{
          fontSize: cityFontSize,
          lineHeight: 1.08,
          marginBottom: compact ? 4 : 6,
          wordBreak: 'break-word',
        }}
      >
        {replaceChars(closestLocation.city_name, '  ', ' - ')}
      </div>
      <div
        style={{
          fontSize: metaFontSize,
          lineHeight: 1.2,
          marginBottom: compact ? 6 : 8,
          wordBreak: 'break-word',
        }}
      >
        Last update: {moment(closestLocation.utc_time).format('MM/DD/YYYY HH:mm:ss')}
      </div>
      <div className="border border-1 border-dark" />

      <div
        className="d-flex align-items-center justify-content-between"
        style={{ gap: compact ? 8 : 12, padding: compact ? '6px 0' : '8px 0' }}
      >
        <div style={{ flex: '0 0 auto' }}>
          <ConditionIcons conditionId={closestLocation.icon} size={iconSize} />
        </div>
        <div
          className="fw-bold"
          style={{
            flex: '1 1 auto',
            minWidth: 0,
            fontSize: summaryFontSize,
            lineHeight: 1.12,
          }}
        >
          <div style={{ wordBreak: 'break-word' }}>{closestLocation.sky}</div>
          <div>{closestLocation.temperature}° F</div>
        </div>
      </div>

      <div className="border border-1 border-dark my-0" />

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: detailsColumns === 2 ? '1fr 1fr' : '1fr',
          columnGap: compact ? 10 : 14,
          rowGap: compact ? 4 : 6,
          paddingTop: compact ? 6 : 8,
          fontSize: detailsFontSize,
          lineHeight: 1.2,
          minWidth: 0,
        }}
      >
        {details.map((detail, index) => (
          <div key={index} style={{ minWidth: 0, wordBreak: 'break-word' }}>
            {detail}
          </div>
        ))}
      </div>
    </div>
  );
}
